/* eslint-disable @typescript-eslint/ban-ts-comment */

interface PromiseFulfilledResult<T> {
  status: 'fulfilled';
  value: T;
}

interface PromiseRejectedResult {
  status: 'rejected';
  reason: any;
}

type PromiseSettledResult<T> =
  | PromiseFulfilledResult<T>
  | PromiseRejectedResult;

export async function processPromises(
  promises: Promise<any>[],
  processResponse = response => response,
  processRejectedPromise = result =>
    console.log('processPromises |', result.reason, result.value),
  resultDefaultField = '_default'
) {
  const promisesResults: PromiseSettledResult<any>[] = await Promise.allSettled(
    promises
  );

  const result = {};

  for (const promiseResult of promisesResults) {
    // @ts-ignore
    if (promiseResult.status === 'rejected') {
      processRejectedPromise(promiseResult);
      continue;
    }

    // @ts-ignore
    const response = promiseResult.value?.response || promiseResult.value;

    let itemId;
    if (response) itemId = response.guid || response.id;

    if (itemId) {
      result[itemId] = processResponse(response);
    } else {
      if (result[resultDefaultField]) {
        result[resultDefaultField].push(processResponse(response));
      } else {
        result[resultDefaultField] = [processResponse(response)];
      }
    }
  }

  return result;
}
